import { put, select, call, all, takeLatest } from "redux-saga/effects";
import FeedbackFormApi from "../api/FeedbackForm";
import StorageApi from "../api/Storage";
import { Auth, FeedbackForm } from "../actions";
// Type
import type { Action } from "deox";
import type { tAPI } from "../api/API";
// Sagas for Feedback Form
function* doFeedbackFormSend(
  action: Action<
    string,
    {
      body: any;
      isPostFile?: boolean;
      callbackSuccess?: () => void;
      callbackError?: (error: any) => void;
    }
  >
) {
  try {
    yield put(FeedbackForm.feedbackFormSendRequest());
    window.logger.log("doFeedbackFormSend", action);
    const {
      body,
      isPostFile: isUpload = false,
      callbackSuccess = undefined,
    } = action.payload;
    const { api, token }: { api: tAPI; token: string } = yield select(
      ({ api }) => api
    );
    let jsonBody: any;
    if (isUpload && body.file) {
      // Upload attachment to S3 first, then send feedback with fileKey
      const userId: string = yield select(({ auth: { user } }) => user._id);
      const { key } = yield call(
        StorageApi.UploadFile,
        api,
        body.file,
        {
          belongsTo: "Users" as const,
          ownerId: userId,
          location: "temporary" as const,
        },
        { token }
      );
      jsonBody = { fileKey: key, description: body.description };
      if (body.priority) {
        jsonBody.priority = body.priority;
      }
    } else {
      jsonBody = body;
    }
    // call the api to send feedback form (always JSON now)
    yield call(FeedbackFormApi.SendFeedbackForm, api, jsonBody, false, {
      token,
    });
    yield put(FeedbackForm.feedbackFormSendSuccess());
    if (callbackSuccess) {
      callbackSuccess();
    }
  } catch (error: any) {
    const { data: errors } = error;
    window.logger.error("ErrorSaga - doFeedbackFormSend", error, errors);
    if (errors) {
      yield put(Auth.authCheckSessionExpiredApp({ errors }));
    }
    yield put(FeedbackForm.feedbackFormSendFailure());
    const { message } = errors || "";
    const { callbackError = undefined } = action.payload;
    if (callbackError) {
      callbackError(message);
    }
  }
}
export default function* feedbackFormSagas(): Generator<any, any, any> {
  yield all([takeLatest(FeedbackForm.FEEDBACK_FORM_SEND, doFeedbackFormSend)]);
}
